(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
	var headerHeight = $('#header').outerHeight();

	$(document.body).on('click', '[data-smooth-scroll]', function (e) {
		e.preventDefault();

		var clicked = $(this);
		var href = clicked.attr('href');
		var target = $(href);

		if (target.length) {
			var top = target.offset().top;

			// <html> for Fx - <body> for the rest
			$(document.body).animate({scrollTop: top - (headerHeight + 16) + 'px'}, 200);
			$(document.documentElement).animate({scrollTop: top - (headerHeight + 16) + 'px'}, 200);

			if (window.history.pushState) {
				window.history.pushState('', document.title, window.location.pathname + window.location.search + href);
			}
		}
	});

	// On page load, if a hash is set and a data-smooth-scroll pointing to the element exists, scroll to it
	if (window.location.hash) {
		var id = window.location.hash.substr(1);

		if (document.getElementById(id)) {
			$('a[href="#' + id + '"][data-smooth-scroll]').click();
		}
	}
})();
